<template>
  <SelectArticle
    :articleIdExcluded="article.id"
    class="SelectArchArticle ib"
    :siteId="article.siteId"
    :value="article.archArticleId"
    @update:value="$up('value', $event)" />
</template>

<script>
import SelectArticle from '@components/fields/SelectArticle'

export default {
  components: { SelectArticle },
  props: {
    article: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    value: { type: null, required: true },
  },
}
</script>

<style lang="scss">
.SelectArchArticle {
}
</style>
